import {InputSelectRepeatDate} from '@/features/agenda/components/agenda-event-form/input-select-repeat-date/InputSelectRepeatDate'
import {AgendaEventFieldsSchema} from '@/features/agenda/formSchemas'
import {generateFrequencyRepetitionId} from '@/features/agenda/utils'
import {useController, useFormContext, useWatch} from 'react-hook-form'
import {z} from 'zod'
import {useMemo} from 'react'
import {RepetitionReturn} from '@/features/agenda/types'

const AgendaRepeatScheduleSelectFieldSchema = AgendaEventFieldsSchema.pick({
    date: true,
    repetitionData: true
})
type AgendaRepeatScheduleSelectFieldSchema = z.infer<typeof AgendaRepeatScheduleSelectFieldSchema>

export const AgendaRepeatScheduleSelectField = () => {
    const {control} = useFormContext<AgendaRepeatScheduleSelectFieldSchema>()
    const date = useWatch({control, name: 'date'})
    const {field} = useController({control, name: 'repetitionData'})

    const selectValue = useMemo(() => {
        return field.value?.frequency && field.value?.position && field.value?.dayOfWeek
            ? generateFrequencyRepetitionId(field.value.frequency, field.value.dayOfWeek, field.value.position)
            : undefined
    }, [field.value])

    const handleChange = (value: RepetitionReturn[keyof RepetitionReturn]) => {
        field.onChange({
            frequency: value?.value.frequency,
            position: value?.value.position,
            dayOfWeek: value?.value.day
        })
    }

    if (!date) return null

    return <InputSelectRepeatDate date={date.date} onChange={handleChange} value={selectValue} />
}
